import type { IconData } from '@stacksjs/iconify-core'

export const computerOldElectronics: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.475 22.86h-4.57v-1.53h1.52v-1.52H4.575v1.52H6.1v1.53H1.525V32h28.95Zm-22.86-1.53h16.76v1.53H7.615Zm21.34 9.15H3.045v-6.1h25.91Zm-1.53-28.96h1.53v18.29h-1.53Z\"/><path fill=\"currentColor\" d=\"M18.285 25.9h7.62v1.53h-7.62Zm0-15.23h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm-4.57 4.57h4.57v1.52h-4.57Zm-1.53-1.52h1.53v1.52h-1.53Zm0-3.05h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M6.1 18.29h19.81V3.05H6.1ZM7.615 4.57h16.76v12.19H7.615ZM6.095 25.9h3.05v3.05h-3.05ZM4.575 0h22.85v1.52H4.575Zm-1.53 1.52h1.53v18.29h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computerOldElectronics
